module.exports = __webpack_public_path__ + "img/car_icon07.59633eca.png";